// Copyright 2016 Sorama B.V.

import { IPlotParent } from "controls/plot/IPlotParent";
import { DrawLayer, IPlotPart, Margin, Pair, Rect, Size } from "controls/plot/IPlotPart";
import { Unit } from "units/Unit";

export abstract class PlotPartBase implements IPlotPart {
    private _drawLayer: DrawLayer;

    //#region Fields

    protected plotParent: IPlotParent;

    protected viewPort: Rect = new Rect(0, 0, 1, 1);
    protected viewPortBounds: Rect = new Rect(0, 0, 1, 1);
    protected size: Size = new Size(0, 0);
    protected actualSize: Size = new Size(0, 0);
    protected margin: Margin = new Margin(0, 0, 0, 0);
    protected sourceUnits: Pair<Unit>;

    //#endregion

    public get drawLayer(): DrawLayer {
        return this._drawLayer;
    }

    //#region Constructor and Initialisation

    // The dummy argument is purely to prevent typescript from using the 'spread' ES2015
    // functionality which in turn causes traceur to transpile it to its internal spread function which causes errors in IE
    constructor(dummyArgument: number, drawLayer?: DrawLayer) {
        this._drawLayer = drawLayer === undefined ? DrawLayer.UserInterface : drawLayer;
    }

    public bind(context: IPlotParent): void {
        this.plotParent = (context as unknown as PlotPartBase).onMeasureMargin
            ? (context as unknown as PlotPartBase).plotParent
            : context;
    }

    public attached(): void {
        this.plotParent.subscribePart(this);
    }

    public detached(): void {
        this.plotParent.unSubscribePart(this);
    }

    //#endregion

    //#region IPlotPart Members
    public onMeasureMargin(): Margin {
        return new Margin(0, 0, 0, 0);
    }

    public onSize(size: Size, margin: Margin): void {
        this.size = size;
        this.margin = margin;

        this.actualSize = new Size(
            Math.max(size.width - margin.left - margin.right, 0),
            Math.max(size.height - margin.top - margin.bottom, 0)
        );
    }

    public onViewPortComputed(viewPort: Rect, viewPortBounds: Rect, units: Pair<Unit>) {
        this.viewPort = viewPort;
        this.viewPortBounds = viewPortBounds;
        this.sourceUnits = units;
    }
    //#endregion
}
